import history from 'history.js'


export const redirect = (path) => () => {
    history.push(path)
}
